import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  padding: 0 0.75rem;
  margin-bottom: 0.5rem;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25rem;
    width: 13rem;
  }
  
  .w1 {
    padding-right: 0.15em !important;
    width: 5rem;

    .top-header {
      display: flex;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      height: 2em !important;
      padding: 0.5em 0em 0.5em 0em !important;
    }
  }

  .icon-button {
    cursor: pointer;
    margin: 0 0.1rem;
  }
`;

export const CardCondPag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 22rem;
  margin-top: 0.7rem;
  overflow: auto;

  .w1 {
    width: 5rem;
  }

  .w2 {
    width: 10rem;
  }

  .w3 {
    width: 15rem;
  }

  .w4 {
    width: 20rem;
  }

  .w5 {
    width: 25rem;
  }

  .card-atv-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.5rem;

    .titulos-tab{
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25rem;
      background: ${Colors.Color4};
      color: ${Colors.Color9};
      border-radius: 0.5rem;

      .col {
        height: 2.5rem;
        padding: 0.5em 0em 0.5em 0.5rem;
        display: flex;
        align-items: center;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }
    }

    .icon-button {
      border: none;
      cursor: pointer;
      background: ${Colors.Color1};
      color: ${Colors.Color7};
      font-size: 1.125rem;
    }
  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: -0.3rem;

    .row-top {
      margin-top: 0em !important;
      display: flex;
      flex-direction: row;
    }

    .row {
      width: auto;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0rem;
        border-radius: 0;
        height: 2.5rem;
      }

      TextArea:focus {
        height: 9.5em !important;
      }
    }
  }
`;